import { Button, Popconfirm } from "antd";

export const getColumns = ({ handleEdit, handleDelete }) => {
  return [
    {
      title: "Cancellation Rule",
      dataIndex: "cancellationRule",
      key: "cancellationRule",
      render: (rule) =>
        rule.length > 0
          ? `${rule[0].chargeType} - ${rule[0].daysBeforeCheckin} days - ${rule[0].chargePercentage}%`
          : "No rule",
    },
    {
      title: "Children Rule",
      dataIndex: "childrenRule",
      key: "childrenRule",
      render: (rule) =>
        rule
          ? `Max Age: ${rule.maxAge}, Free Stay: ${
              rule.freeStay ? "Yes" : `Charge: ${rule.additionalChildCharge}`
            }`
          : "No rule",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <>
          <Button
            onClick={() => handleEdit(record)}
            type="primary"
            style={{ marginRight: 8 }}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure to delete this policy?"
            onConfirm={() => handleDelete(record._id)}
            onCancel={() => {}}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];
};
